import request from '@/utils/request'

export const queryChartData = async(uri: string, data: any): Promise<any> => {
  return request({
    url: uri,
    method: 'get',
    params: data
  })
}
